import { Dimensions } from 'react-native';
import styled from 'styled-components/native';

const windowWidth = Dimensions.get('window').width;

export const Container = styled.View`
    margin-left: ${windowWidth > 650 ? '-53px' : '0px'};
`;
